import { useEffect, useRef, useState } from 'react';

// Starts visible when IntersectionObserver is missing so content is never
// stuck hidden on old browsers.
export function useReveal() {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(() => typeof IntersectionObserver === 'undefined');

    useEffect(() => {
        const node = ref.current;
        if (!node || isVisible) return undefined;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

        observer.observe(node);
        return () => observer.disconnect();
    }, [isVisible]);

    return { ref, isVisible };
}
